import React, { useEffect, useState } from "react";
import SearchResultCardComponent from "../../Components/card/searchResultCard";
import { getUserData } from "../../Utils/localStorageUtils";
import { getUserShortlistedProperties } from "../../services/shortlistService";
import { addInterestedUser } from "../../services/propertyService";
import { useToast } from "../../hooks/useToast";
const DataTableSection = ({ searchResults = [] }) => {
  const { _id: userId } = getUserData() || {}; // Get user ID
  const [shortlistedPropertyIds, setShortlistedPropertyIds] = useState(new Set()); // ✅ Store only IDs
  const [loading, setLoading] = useState(true); // ✅ Loading state


  const [loadingPropertyId, setLoadingPropertyId] = useState(null); // Track loading per project
  const [connectedProperties, setConnectedProperties] = useState([]); // Track successfully connected projects

  const { showSuccess, showError } = useToast();


  // Fetch user's shortlisted properties once
  useEffect(() => {
    if (!userId) {
      setLoading(false); // ✅ If no user, stop loading
      return;
    }


    const fetchShortlist = async () => {
      try {
        const data = await getUserShortlistedProperties(userId);
        setShortlistedPropertyIds(new Set(data.propertyIds)); // ✅ Store only IDs in a Set for quick lookup
      } catch (error) {
        console.error("Error fetching shortlisted properties:", error);
      } finally {
        setLoading(false); // ✅ Stop loading after API call
      }
    };

    fetchShortlist();
  }, [userId]); // ✅ Runs once when userId changes





  const handleContactOwner = async (propertyId) => {
    if (connectedProperties.includes(propertyId)) return; // If already connected, do nothing

    setLoadingPropertyId(propertyId); // Set loading state for this project

    try {
      const response = await addInterestedUser(propertyId,userId);
      if (response.success) {
        showSuccess(response?.message || "Successfully connected with the builder!");
        setConnectedProperties((prev) => [...prev, propertyId]); // Mark as connected
      } else {
        showError(response.message || "Failed to connect.");
      }
    } catch (error) {
      showError("Something went wrong, please try again.");
    }

    setLoadingPropertyId(null); // Reset loading state
  };



  return (
    <div>
      {loading ? (
        <p>Loading shortlisted properties...</p> // ✅ Show loading message
      ) : (
        searchResults?.map((item) => (
          <div key={item._id} className="py-2">
            <SearchResultCardComponent
              property={item}
              isShortlisted={shortlistedPropertyIds.has(item._id)} // ✅ Pass shortlist state as prop

              onContactOwner={handleContactOwner} // Pass function as prop
              loading={loadingPropertyId === item._id} // Track loading state
              connected={connectedProperties.includes(item._id)} // Check if already connected
            />
          </div>
        ))
      )}
    </div>
  );
};

export default DataTableSection;
